import { AnyAction } from 'redux';
import { SET_UNSAVED_CHANGES, SET_WINDOW_DIMENSIONS } from '../types/types';

const initialState = {
	unsavedChanges: false,
	width: 0,
	height: 0
};

export default function globalReducer(state = initialState, action: AnyAction) {
	switch (action.type) {
		case SET_UNSAVED_CHANGES:
			return { ...state, unsavedChanges: action.payload.unsavedChanges };
		case SET_WINDOW_DIMENSIONS:
			return {
				...state,
				width: action.payload.width,
				height: action.payload.height
			};
		default:
			return state;
	}
}
